import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export const committeeDate = (value) => {
  if (!value) return "—";
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const committeeTenure = (member) => member.tenure_from
  ? `${committeeDate(member.tenure_from)} – ${member.tenure_to ? committeeDate(member.tenure_to) : "Present"}`
  : "To be updated";

export function buildCommitteePdf(members, district = null, { includeMobile = false } = {}) {
  const rows = members.filter((member) => member.is_active !== false && member.is_active !== 0
    && member.is_active !== "0" && (district
      ? member.committee_level === "district" && member.district === district
      : (member.committee_level || "state") === "state"));
  if (!rows.length) throw new Error("No published committee members are available for this committee.");
  const doc = new jsPDF({ format: "a4", unit: "mm" });
  const title = district ? `${district} District Committee` : "State Committee";
  const header = () => {
    doc.setFillColor(18, 60, 50);
    doc.rect(0, 0, 210, 47, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("PARA SPORTS ASSOCIATION", 14, 15);
    doc.text("OF ANDHRA PRADESH", 14, 22);
    doc.setFontSize(12);
    doc.text(doc.splitTextToSize(title, 180), 14, 34);
  };
  autoTable(doc, {
    startY: 56,
    margin: { top: 56, bottom: 22, left: 14, right: 14 },
    head: [["S.No.", "Member Name", "Designation", ...(includeMobile ? ["Mobile"] : []), "Tenure From", "Tenure To"]],
    body: rows.map((member, index) => [index + 1, member.name, member.designation, ...(includeMobile ? [member.mobile || "-"] : []),
      member.tenure_from ? committeeDate(member.tenure_from) : "-",
      member.tenure_to ? committeeDate(member.tenure_to) : member.tenure_from ? "Present" : "-"]),
    theme: "striped",
    styles: { font: "helvetica", fontSize: 9, cellPadding: 3, overflow: "linebreak", valign: "middle" },
    headStyles: { fillColor: [18, 60, 50], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [240, 247, 243] },
    columnStyles: includeMobile
      ? { 0: { cellWidth: 12 }, 1: { cellWidth: 39 }, 2: { cellWidth: 37 }, 3: { cellWidth: 32 }, 4: { cellWidth: 31 }, 5: { cellWidth: 31 } }
      : { 0: { cellWidth: 12 }, 1: { cellWidth: 52 }, 2: { cellWidth: 50 }, 3: { cellWidth: 34 }, 4: { cellWidth: 34 } },
    rowPageBreak: "avoid",
    willDrawPage: header,
  });
  const pages = doc.getNumberOfPages();
  const generated = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric" });
  for (let page = 1; page <= pages; page++) {
    doc.setPage(page);
    doc.setDrawColor(210, 220, 215);
    doc.line(14, 278, 196, 278);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(80, 95, 88);
    doc.text(`Published committee directory | Generated ${generated}`, 14, 284);
    doc.text(`Page ${page} of ${pages}`, 196, 284, { align: "right" });
  }
  return doc;
}

export function downloadCommitteePdf(members, district = null, options = {}) {
  const filename = `${district || "Andhra-Pradesh-State"}-Committee.pdf`.replace(/[^a-zA-Z0-9._-]/g, "-");
  buildCommitteePdf(members, district, options).save(filename);
}
